'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import AdWordsCampaignEntityRecord from 'AdsUI/records/rmf/AdWordsCampaignEntityRecord';
import { getUpdatedReducerMap } from 'AdsUI/lib/ReducerHelpers'; // initialState reset
// normalize
//

const normalizeCampaignPayload = campaignPayload => {
  const payload = Object.assign({}, campaignPayload);

  if (payload.adGroups) {
    const adGroupIds = payload.adGroups.map(ag => {
      return ag.id;
    });
    payload.adGroups = adGroupIds;
  }

  return payload;
};

const initialState = ImmutableMap();
export default ((state = initialState, action) => {
  const {
    type,
    payload = {}
  } = action;

  switch (type) {
    case Actions.ADWORDS_CAMPAIGN_ENTITY_FETCH_SUCCEEDED:
    case Actions.ADWORDS_CAMPAIGN_ENTITY_REMOVE_SUCCEEDED:
      // need a way to properly parse responses into the immutable
      state = getUpdatedReducerMap(state, normalizeCampaignPayload(payload), AdWordsCampaignEntityRecord);
      break;
    // Eventually it'd be nice for these types of updates to also be generic - would require
    // being able to merge nested records properly as well.

    case Actions.ADWORDS_CAMPAIGN_ENTITY_DAILY_BUDGET_UPDATE:
      state = state.mergeIn([payload.campaignId, 'budget'], payload.data);
      break;

    case Actions.ADWORDS_CAMPAIGN_STATE_INVALIDATE:
      state = initialState;
      break;

    default:
      break;
  }

  return state;
});